<p *ngIf='!isCalculating && message' class='message' [ngClass]="{'error': isError}">{{ message }}</p>
<div class="image-container" *ngIf="!!previewDataURL && !isCalculating">
	<img [src]="previewDataURL" class="branding--ad-preview--image" />
</div>
<cass-indeterminate-circular-progress-indicator *ngIf="isCalculating"></cass-indeterminate-circular-progress-indicator>
